import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 8.1V2a.666.666 0 1 0-1.333 0v6.1a2.77 2.77 0 0 0-2 2.667c0 1.366 1.013 3.866 2.666 3.866S14 12.133 14 10.767A2.77 2.77 0 0 0 12 8.1m-.667 5.233C10.8 13.333 10 11.82 10 10.8a1.407 1.407 0 0 1 1.333-1.467 1.407 1.407 0 0 1 1.334 1.467c0 1.02-.8 2.533-1.334 2.533m-4.666-12A.667.667 0 0 0 6 2v3.64l-.667.447V2A.667.667 0 1 0 4 2v4.087l-.667-.447V2A.667.667 0 1 0 2 2v4a.67.67 0 0 0 .3.553L4 7.693V14a.666.666 0 1 0 1.333 0V7.693l1.7-1.14a.67.67 0 0 0 .3-.553V2a.667.667 0 0 0-.666-.667"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })